import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'source']
  static values = { match: Array }

  connect() {
    this.update()
  }

  update() {
    const visible = this.matchValue.map((value) => String(value)).includes(this.currentValue())

    this.contentTargets.forEach((target) => {
      target.classList.toggle('d-none', !visible)
    })
  }

  currentValue() {
    if (this.hasSourceTarget) {
      return this.#valueOf(this.sourceTarget)
    }

    const checked = this.element.querySelector('input[type=radio]:checked, input[type=checkbox]:checked')
    if (checked) {
      return String(checked.value)
    }

    const field = this.element.querySelector('select, input')
    return field ? String(field.value) : ''
  }

  // A checkbox keeps its `value` attribute whether or not it is ticked, so its
  // contribution depends on `checked` — lets one checkbox in a group drive the toggle.
  #valueOf(element) {
    if (element.type === 'checkbox') {
      return element.checked ? String(element.value) : ''
    }

    return String(element.value)
  }
}
